import { render } from "./ManageDistributors.vue?vue&type=template&id=2c242a44"
import script from "./ManageDistributors.vue?vue&type=script&lang=js"
export * from "./ManageDistributors.vue?vue&type=script&lang=js"

import "./ManageDistributors.vue?vue&type=style&index=0&id=2c242a44&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__